module.exports = __webpack_public_path__ + "montserrat-regular-webfont.362ffe720ba40be35930.eot";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.eot
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.eot
// module chunks = 11